import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgPlaneDeparture = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="url(#planeDeparture_svg__a)"
        d="M19.62 17.2H4.52c-.35 0-.63.3-.63.68 0 .36.28.67.63.67h15.1c.34 0 .63-.3.63-.67s-.3-.67-.63-.67"
      />
      <path
        fill="url(#planeDeparture_svg__b)"
        d="M5.6 13.06c.34.41.87.58 1.37.44l11.77-3.35c1.57-.45 2.25-1.65 1.93-2.47-.23-.58-1.04-1.42-3.26-.61l-3.7 1.36a1 1 0 0 1-.8-.05L7.25 5.54a.8.8 0 0 0-.64-.04l-.43.15c-.16.06-.21.27-.1.4l3.42 3.9-2.16.79-3.2-1.22a.5.5 0 0 0-.51.1l-.28.27a.3.3 0 0 0-.03.43z"
      />
      <path
        fill="url(#planeDeparture_svg__c)"
        d="M6.88 5.76q.13 0 .24.06l5.67 2.84a1.3 1.3 0 0 0 1.01.06l3.7-1.36q.88-.32 1.54-.32c.96 0 1.27.53 1.36.76q.14.35-.06.8c-.25.55-.88 1.02-1.68 1.25L6.9 13.2a1 1 0 0 1-1.08-.35l-2.28-2.72.28-.27a.2.2 0 0 1 .23-.05l3.2 1.22.1.04.09-.04 2.15-.78.43-.16-.3-.35-3.36-3.83.35-.12zm0-.31-.27.05-.43.15c-.16.06-.21.27-.1.4l3.42 3.9-2.16.79-3.2-1.22a.5.5 0 0 0-.51.1l-.28.28a.3.3 0 0 0-.03.42l2.28 2.74a1.3 1.3 0 0 0 1.37.44l11.77-3.35c1.57-.45 2.25-1.65 1.93-2.47-.16-.4-.6-.95-1.64-.95q-.64-.01-1.62.34l-3.7 1.36a1 1 0 0 1-.8-.05L7.25 5.54a1 1 0 0 0-.37-.1"
      />
      <defs>
        <linearGradient
          id="planeDeparture_svg__a"
          x1={7.85}
          x2={16.75}
          y1={13}
          y2={22}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7f78a1" stopOpacity={0.95} />
          <stop offset={1} stopColor="#7f78a1" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="planeDeparture_svg__b"
          x1={12}
          x2={12}
          y1={6.3}
          y2={13}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#86e8ff" />
          <stop offset={1} stopColor="#00a1fc" />
        </linearGradient>
        <linearGradient
          id="planeDeparture_svg__c"
          x1={7.5}
          x2={16.8}
          y1={4.25}
          y2={13}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.3} />
        </linearGradient>
      </defs>
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgPlaneDeparture);
export default Memo;
